import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.5 11.999a8.499 8.499 0 1 1 16.997 0 8.499 8.499 0 0 1-16.997 0M11.999 2C6.477 2 2 6.477 2 11.999s4.477 9.998 9.999 9.998 9.998-4.476 9.998-9.998S17.521 2 12 2m-.393 14.555v1.638h.871v-1.638c1.911-.13 3.042-1.34 3.042-2.86 0-1.755-1.118-2.405-3.042-2.717V8.313c.793.13 1.196.585 1.34 1.378h1.533c-.156-1.612-1.196-2.483-2.873-2.64V5.87h-.87v1.17C9.837 7.156 8.68 8.235 8.68 9.678c0 1.65 1.001 2.353 2.925 2.678v2.925c-1.235-.156-1.52-.871-1.625-1.716H8.37c.13 1.573 1.014 2.834 3.237 2.99m.871-4.056c1.131.247 1.443.61 1.443 1.352 0 .767-.572 1.313-1.443 1.43zm-.87-1.664c-1.145-.234-1.392-.624-1.392-1.3 0-.65.494-1.157 1.391-1.261z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }